import { errorApiRef, useApi } from '@backstage/core-plugin-api'
import { useCallback } from 'react'

import { circleCIApiRef } from '../api'

export function useActionOutput() {
  const api = useApi(circleCIApiRef)
  const errorApi = useApi(errorApiRef)

  const getActionOutput = useCallback(
    async (url: string) => {
      if (!url) {
        return Promise.resolve([])
      }

      try {
        return await api.getBuildStepActionOutput(url)
      } catch (e) {
        errorApi.post(e as Error)
        return Promise.reject(e)
      }
    },
    [api, errorApi]
  )

  return { getActionOutput }
}
